var _path;
import * as React from "react";
function SvgChevronBoldLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.805 18.756L25.047 4.515a1.759 1.759 0 012.487 0l1.661 1.661c.686.686.687 1.797.003 2.484L17.91 20l11.286 11.34a1.758 1.758 0 01-.003 2.484l-1.661 1.661c-.687.687-1.8.687-2.487 0l-14.24-14.242a1.759 1.759 0 010-2.487z"
  })));
}
export default SvgChevronBoldLeft;